import { IconButton, CloseButton as CloseButton$1, Box, Button, InputGroup, Input as Input$1, InputRightElement, InputRightAddon, Icon, Flex, Text, SimpleGrid, useBreakpointValue, Stack, Divider, HStack, Spacer, FormControl, FormLabel, FormErrorMessage, StackDivider } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronUpIcon, ArrowRightIcon, ChevronRightIcon, ChevronDownIcon, ArrowLeftIcon, CloseIcon, CalendarIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import React, { createContext, useContext, useRef, useMemo, forwardRef, useState, useEffect, useImperativeHandle } from 'react';
import _ from 'lodash-es';
import { monthLabelFormat, weekdayLabelFormat, useDay, isStartDate, isEndDate, parseDate, useMonth, useDatepicker, getInputValue, START_DATE as START_DATE$1, END_DATE as END_DATE$1 } from '@datepicker-react/hooks';
export { monthLabelFormat as monthLabelFormatFn, weekdayLabelFormat as weekdayLabelFormatFn } from '@datepicker-react/hooks';
import dateFormat from 'date-fns/format';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { DB_DATE_PATTERN } from '@laliga-cdac/utils';
import { START_DATE, END_DATE } from '@datepicker-react/styled';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var emptyStylesObject = {
  actionButton: {
    position: 'relative',
    color: 'black',
    backgroundColor: 'unset',
    colorScheme: 'corporateGrey.100'
  },
  arrowIcon: {
    my: [5, 15],
    color: 'gray.500'
  },
  buttonsWrapper: {},
  closeButton: {
    top: 1,
    right: 1,
    zIndex: 1,
    position: 'absolute'
  },
  datepickerContainer: {
    background: 'white',
    borderRadius: 'md',
    position: 'relative',
    width: 'fit-content',
    shadow: 'md',
    px: [3, 5],
    py: [5, 7],
    zIndex: 2
  },
  datepickerFooter: {
    justifyContent: 'center',
    pt: [1, 3]
  },
  dateRangeInputContainer: {
    spacing: 5
  },
  dateRangeInputDivider: {},
  day: {
    base: {
      height: ['32px'],
      width: ['100%'],
      minW: ['32px'],
      display: 'flex',
      justifyContent: 'center',
      minWidth: 'unset',
      fontWeight: 'medium',
      fontSize: '13px',
      border: '2px solid',
      textColor: 'gray.900',
      borderRadius: '100%',
      borderColor: 'transparent',
      background: 'transparent',
      overflow: 'hidden',
      _hover: {
        borderColor: 'transparent',
        background: 'transparent'
      }
    },
    normal: {
      _hover: {
        borderColor: 'corporateBlue.500'
      }
    },
    rangeHover: {
      textColor: 'white'
    },
    selected: {
      textColor: 'white',
      fontWeight: 'bold',
      _hover: {
        borderColor: 'black'
      }
    },
    firstOrLast: {
      textColor: 'white',
      background: 'corporateBlue.500',
      _hover: {
        textColor: 'white',
        background: 'corporateBlue.500'
      }
    },
    first: {},
    last: {}
  },
  dayContainer: {
    base: {
      height: ['32px'],
      width: ['32px'],
      _hover: {
        borderRightRadius: '100%'
      }
    },
    normal: {},
    rangeHover: {
      background: 'corporateBlue.500',
      _hover: {
        borderRightRadius: '100%'
      }
    },
    selected: {
      background: 'corporateBlue.500',
      _hover: {
        borderRightRadius: '0%'
      }
    },
    firstOrLast: {
      background: 'corporateBlue.500'
    },
    first: {
      borderLeftRadius: '100%'
    },
    last: {
      borderRightRadius: '100%',
      _hover: {
        borderRightRadius: '100%'
      }
    }
  },
  inputComponentInputGroup: {
    base: {},
    active: {}
  },
  inputComponentInput: {
    base: {},
    active: {}
  },
  inputComponentIcon: {
    base: {},
    active: {}
  },
  inputComponentInputAddon: {
    base: {
      color: 'corporateBlue.500',
      h: 'auto'
    },
    active: {}
  },
  resetDateIcon: {
    color: 'corporateGrey.500',
    backgroundColor: 'transparent',
    w: {
      base: 2,
      md: 3,
      lg: 3
    },
    h: {
      base: 2,
      md: 3,
      lg: 3
    }
  },
  clearDateRightAddon: {
    h: {}
  },
  monthContainer: {
    height: 'unset'
  },
  monthWeekdayLabel: {
    justifyContent: 'center',
    color: 'gray.500',
    mb: 4,
    fontSize: ['10px'],
    textTransform: 'uppercase'
  },
  monthDayGrid: {
    rowGap: 1
  },
  monthMonthLabel: {
    justifyContent: 'center',
    alignItems: 'center',
    mb: 6,
    fontSize: ['14px'],
    color: 'corporateBlue.500',
    marginBottom: 'unset',
    textTransform: 'uppercase'
  },
  monthsWrapper: {
    spacing: [0, 8]
  },
  resetDatesButton: {
    color: 'corporateGrey.500',
    backgroundColor: 'transparent',
    w: {
      base: 2,
      md: 3,
      lg: 3
    },
    h: {
      base: 2,
      md: 3,
      lg: 3
    }
  },
  selectDateContainer: {
    base: {
      width: '100%',
      borderBottom: '2px solid',
      borderColor: 'gray.300',
      paddingBottom: [1, 3]
    },
    active: {
      borderColor: 'blue.400'
    }
  },
  selectDateText: {
    base: {
      fontSize: 'xs',
      color: 'gray.500'
    },
    active: {}
  },
  selectDateDateText: {
    base: {
      fontWeight: 'bold',
      fontSize: ['15px']
    },
    active: {}
  },
  todayButtonWrapper: {
    justifyContent: 'center',
    mt: '8px'
  },
  todayButtonText: {
    color: 'corporateBlue.500',
    cursor: 'pointer',
    fontSize: '14px'
  },
  todayButtonDivider: {
    marginTop: 'auto'
  },
  monthTopDivider: {
    mb: 2,
    mt: 2
  },
  doubleArrowIcon: {
    width: '10px'
  },
  formLabel: {},
  formErrorMessage: {}
};
var StylesContext = /*#__PURE__*/createContext({
  styles: emptyStylesObject,
  overwriteDefaultStyles: false
});

var StylesProvider = function StylesProvider(_ref) {
  var children = _ref.children,
      _ref$overwriteDefault = _ref.overwriteDefaultStyles,
      overwriteDefaultStyles = _ref$overwriteDefault === void 0 ? false : _ref$overwriteDefault,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles;
  return React.createElement(StylesContext.Provider, {
    value: {
      overwriteDefaultStyles: overwriteDefaultStyles,
      styles: _.merge(emptyStylesObject, styles)
    }
  }, children);
};

var _excluded = ["direction", "doubleArrowIcon"];

var ActionButton = function ActionButton(_ref) {
  var direction = _ref.direction,
      doubleArrowIcon = _ref.doubleArrowIcon,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var IconComponent = ChevronLeftIcon;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref2 = styles || {},
      actionButton = _ref2.actionButton;

  if (direction === 'up') {
    IconComponent = ChevronUpIcon;
  } else if (direction === 'right') {
    IconComponent = doubleArrowIcon ? ArrowRightIcon : ChevronRightIcon;
  } else if (direction === 'down') {
    IconComponent = ChevronDownIcon;
  } else if (direction === 'left') {
    IconComponent = doubleArrowIcon ? ArrowLeftIcon : ChevronLeftIcon;
  }

  return React.createElement(IconButton, Object.assign({
    "aria-label": "Arrow " + direction,
    icon: React.createElement(IconComponent, null)
  }, props, actionButton));
};

var CloseButton = function CloseButton(props) {
  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref = styles || {},
      closeButton = _ref.closeButton;

  return React.createElement(CloseButton$1, Object.assign({}, closeButton, props));
};

var datepickerPhrases = {
  datepickerStartDatePlaceholder: 'Seleccione una fecha',
  datepickerStartDateLabel: 'Fecha de Inicio:',
  datepickerEndDatePlaceholder: 'Selecciona',
  datepickerEndDateLabel: 'Fecha fin:',
  resetDates: 'Reiniciar fechas',
  close: 'Cerrar'
};

var dateRangeInputPhrases = /*#__PURE__*/_extends({}, datepickerPhrases, {
  startDateAriaLabel: 'Fecha de Inicio',
  endDateAriaLabel: 'Fecha fin',
  startDatePlaceholder: 'Fecha de Inicio',
  endDatePlaceholder: 'Fecha fin'
});

var dateSingleInputPhrases = /*#__PURE__*/_extends({}, datepickerPhrases, {
  dateAriaLabel: 'Seleccione una fecha',
  datePlaceholder: 'Seleccione una fecha'
});

var defaultMaxYear = 2999;

var formatValidYear = function formatValidYear(date, maxYear) {
  var newDate = date && new Date(date.getTime());
  if (newDate && newDate.getFullYear() > maxYear) newDate.setFullYear(maxYear);
  return newDate;
};

var dateIsEqual = function dateIsEqual(date, dateFormated) {
  return dateFormated && date && dateFormated.getTime() === date.getTime();
};

var dayLabelFormatFn = function dayLabelFormatFn(date) {
  return dateFormat(date, 'd');
};

var defaultDisplayFormat = 'dd/MM/yyyy';

var formatDateDatepicker = function formatDateDatepicker(date, pattern) {
  if (pattern === void 0) {
    pattern = DB_DATE_PATTERN;
  }

  if (!date) return null;
  return format(new Date(date), pattern, {
    locale: es
  });
};

var formatDateToISO = function formatDateToISO(date) {
  if (date) {
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 1).toString().length < 2 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1).toString();
    var day = date.getDate().toString().length < 2 ? "0" + date.getDate() : date.getDate().toString();
    return year + "-" + month + "-" + day;
  }

  return '';
};

var _excluded$1 = ["children"];
var defaultBase = {
  startDate: null,
  endDate: null,
  focusedInput: null,
  onDayRender: undefined,
  displayFormat: defaultDisplayFormat,
  phrases: datepickerPhrases,
  vertical: false,
  showResetDates: false,
  isRangePicker: false,
  handleResetEndDate: undefined
};
var defaultFormatters = {
  monthLabelFormat: monthLabelFormat,
  weekdayLabelFormat: weekdayLabelFormat,
  dayLabelFormat: dayLabelFormatFn
};
var defaultUseDatepicker = {
  numberOfMonths: 2,
  activeMonths: [],
  firstDayOfWeek: 0,
  focusedDate: null,
  hoveredDate: null,
  goToDate: function goToDate() {},
  goToNextMonths: function goToNextMonths() {},
  goToNextMonthsByOneMonth: function goToNextMonthsByOneMonth() {},
  goToNextYear: function goToNextYear() {},
  goToPreviousMonths: function goToPreviousMonths() {},
  goToPreviousMonthsByOneMonth: function goToPreviousMonthsByOneMonth() {},
  goToPreviousYear: function goToPreviousYear() {},
  isDateBlocked: function isDateBlocked() {
    return false;
  },
  isDateFocused: function isDateFocused() {
    return false;
  },
  isDateHovered: function isDateHovered() {
    return false;
  },
  isDateSelected: function isDateSelected() {
    return false;
  },
  isEndDate: function isEndDate() {
    return false;
  },
  isFirstOrLastSelectedDate: function isFirstOrLastSelectedDate() {
    return false;
  },
  isStartDate: function isStartDate() {
    return false;
  },
  onDateFocus: function onDateFocus() {},
  onDateHover: function onDateHover() {},
  onDateSelect: function onDateSelect() {},
  onResetDates: function onResetDates() {}
};

var datepickerContextDefaultValue = /*#__PURE__*/_extends({}, defaultBase, defaultFormatters, defaultUseDatepicker);

var DatepickerContext = /*#__PURE__*/React.createContext(datepickerContextDefaultValue);

var useDatepickerContext = function useDatepickerContext() {
  return useContext(DatepickerContext);
};

var DatepickerProvider = function DatepickerProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return React.createElement(DatepickerContext.Provider, {
    value: _extends({}, datepickerContextDefaultValue, props)
  }, children);
};

function getColor(_ref, _ref2) {
  var isSelected = _ref.isSelected,
      isWithinHoverRange = _ref.isWithinHoverRange,
      isFirst = _ref.isFirst,
      isLast = _ref.isLast;
  var base = _ref2.base,
      normal = _ref2.normal,
      rangeHover = _ref2.rangeHover,
      selected = _ref2.selected,
      firstOrLast = _ref2.firstOrLast,
      first = _ref2.first,
      last = _ref2.last;
  var style = base;
  if (!isSelected && !isWithinHoverRange) style = _extends({}, style, normal);
  if (isSelected) style = _extends({}, style, selected);
  if (isWithinHoverRange) style = _extends({}, style, rangeHover);
  if (isFirst || isLast) style = _extends({}, style, firstOrLast);
  if (isFirst) style = _extends({}, style, first);
  if (isLast) style = _extends({}, style, last);
  return style;
}

function Day(_ref3) {
  var day = _ref3.day,
      date = _ref3.date,
      handleResetEndDate = _ref3.handleResetEndDate;
  var dayRef = useRef(null);

  var _useDatepickerContext = useDatepickerContext(),
      focusedDate = _useDatepickerContext.focusedDate,
      isDateFocused = _useDatepickerContext.isDateFocused,
      isDateSelected = _useDatepickerContext.isDateSelected,
      isDateHovered = _useDatepickerContext.isDateHovered,
      isDateBlocked = _useDatepickerContext.isDateBlocked,
      isFirstOrLastSelectedDate = _useDatepickerContext.isFirstOrLastSelectedDate,
      onDateSelect = _useDatepickerContext.onDateSelect,
      onDateFocus = _useDatepickerContext.onDateFocus,
      onDateHover = _useDatepickerContext.onDateHover,
      onDayRender = _useDatepickerContext.onDayRender,
      startDate = _useDatepickerContext.startDate,
      endDate = _useDatepickerContext.endDate;

  var dayProps = useDay({
    date: date,
    focusedDate: focusedDate,
    isDateFocused: isDateFocused,
    isDateSelected: isDateSelected,
    isDateHovered: isDateHovered,
    isDateBlocked: isDateBlocked,
    isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
    onDateFocus: onDateFocus,
    onDateSelect: onDateSelect,
    onDateHover: onDateHover,
    dayRef: dayRef
  });
  var onClick = dayProps.onClick,
      onKeyDown = dayProps.onKeyDown,
      onMouseEnter = dayProps.onMouseEnter,
      tabIndex = dayProps.tabIndex,
      isSelectedStartOrEnd = dayProps.isSelectedStartOrEnd,
      isSelected = dayProps.isSelected,
      isWithinHoverRange = dayProps.isWithinHoverRange,
      disabledDate = dayProps.disabledDate;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref4 = styles || {},
      dayContainer = _ref4.dayContainer,
      styledDay = _ref4.day;

  var isFirst = isStartDate(date, startDate);
  var isLast = isEndDate(date, endDate);
  var containerStyle = useMemo(function () {
    return getColor({
      isFirst: isFirst,
      isLast: isLast,
      isSelected: isSelected,
      isWithinHoverRange: isWithinHoverRange,
      isSelectedStartOrEnd: isSelectedStartOrEnd,
      disabledDate: disabledDate
    }, {
      base: dayContainer.base,
      normal: dayContainer.normal,
      rangeHover: dayContainer.rangeHover,
      selected: dayContainer.selected,
      first: dayContainer.first,
      last: dayContainer.last,
      firstOrLast: dayContainer.firstOrLast
    });
  }, [isFirst, isLast, isSelected, isWithinHoverRange, isSelectedStartOrEnd, disabledDate]);
  var buttonStyle = useMemo(function () {
    return getColor({
      isFirst: isFirst,
      isLast: isLast,
      isSelected: isSelected,
      isWithinHoverRange: isWithinHoverRange,
      isSelectedStartOrEnd: isSelectedStartOrEnd,
      disabledDate: disabledDate
    }, {
      base: styledDay.base,
      normal: styledDay.normal,
      rangeHover: styledDay.rangeHover,
      selected: styledDay.selected,
      first: styledDay.first,
      last: styledDay.last,
      firstOrLast: styledDay.firstOrLast
    });
  }, [isFirst, isLast, isSelected, isWithinHoverRange, isSelectedStartOrEnd, disabledDate]);

  var handleClickSelectDay = function handleClickSelectDay() {
    onClick();

    if (startDate && endDate) {
      handleResetEndDate == null ? void 0 : handleResetEndDate(date);
    }
  };

  return React.createElement(Box, Object.assign({}, containerStyle), React.createElement(Button, Object.assign({}, buttonStyle, {
    variant: "unstyled",
    onClick: handleClickSelectDay,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    ref: dayRef,
    disabled: disabledDate,
    "data-testid": "Day",
    "aria-label": "Day-" + date.toDateString(),
    type: "button"
  }), typeof onDayRender === 'function' ? onDayRender(date, {
    isFirst: isFirst,
    isLast: isLast,
    isSelected: isSelected,
    isWithinHoverRange: isWithinHoverRange,
    isSelectedStartOrEnd: isSelectedStartOrEnd,
    disabledDate: disabledDate
  }) : day));
}

var getStateStyle = function getStateStyle(_ref, isActive) {
  var base = _ref.base,
      active = _ref.active;
  return isActive ? _extends({}, base, active) : base;
};

var WRAPPED_POSITIONS = {
  xs: '56px',
  sm: '62px',
  md: '76px',
  lg: '80px',
  xl: '84px',
  '2xl': '96px'
};

var getWrapperPosition = function getWrapperPosition(size) {
  return WRAPPED_POSITIONS[size] || '56px';
};

var _excluded$2 = ["dateFormat", "disableAccessibility", "iconComponent", "id", "isActive", "name", "onChange", "onClick", "placeholder", "showCalendarIcon", "value", "allowEditableInputs", "handleResetDate", "hideResetDateAddon", "handleOnFocusChange"];
var Input = /*#__PURE__*/forwardRef(function (props, inputRef) {
  var _props$dateFormat = props.dateFormat,
      dateFormat = _props$dateFormat === void 0 ? defaultDisplayFormat : _props$dateFormat,
      disableAccessibility = props.disableAccessibility,
      _props$iconComponent = props.iconComponent,
      iconComponent = _props$iconComponent === void 0 ? CalendarIcon : _props$iconComponent,
      id = props.id,
      _props$isActive = props.isActive,
      isActive = _props$isActive === void 0 ? false : _props$isActive,
      name = props.name,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
      placeholder = props.placeholder,
      _props$showCalendarIc = props.showCalendarIcon,
      showCalendarIcon = _props$showCalendarIc === void 0 ? true : _props$showCalendarIc,
      value = props.value,
      _props$allowEditableI = props.allowEditableInputs,
      allowEditableInputs = _props$allowEditableI === void 0 ? false : _props$allowEditableI,
      handleResetDate = props.handleResetDate,
      hideResetDateAddon = props.hideResetDateAddon,
      handleOnFocusChange = props.handleOnFocusChange,
      inputProps = _objectWithoutPropertiesLoose(props, _excluded$2);

  var ref = useRef(null);

  var _useState = useState(value),
      searchString = _useState[0],
      setSearchString = _useState[1];

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref = styles || {},
      inputComponentInputGroup = _ref.inputComponentInputGroup,
      inputComponentInput = _ref.inputComponentInput,
      clearDateRightAddon = _ref.clearDateRightAddon,
      resetDateIcon = _ref.resetDateIcon,
      inputComponentInputAddon = _ref.inputComponentInputAddon,
      inputComponentIcon = _ref.inputComponentIcon; // Note: value was updated outside of InputComponent


  useEffect(function () {
    setSearchString(value);
  }, [value]);

  function handleOnChange(e) {
    var dateValue = e.target.value;
    setSearchString(dateValue);

    if (typeof ref.current === 'number') {
      clearTimeout(ref.current);
    }

    ref.current = setTimeout(function () {
      onClick();
      var parsedDate = parseDate(dateValue, dateFormat, new Date());
      var isValidDate = !isNaN(parsedDate.getDate());

      if (isValidDate) {
        onChange(parsedDate);
      } else {
        onChange(null);
      }
    }, 1000);
  }

  function handleOnFocus(_e) {
    onClick();
  }

  var handleResetInputDate = function handleResetInputDate() {
    handleResetDate();
    onChange(null);
    handleOnFocusChange(false);
  };

  return React.createElement(InputGroup, Object.assign({
    size: inputProps == null ? void 0 : inputProps.size
  }, getStateStyle(inputComponentInputGroup, isActive), {
    htmlFor: id
  }), React.createElement(InputGroup, null, React.createElement(Input$1, Object.assign({
    size: "sm"
  }, inputProps, getStateStyle(inputComponentInput, isActive), {
    ref: inputRef,
    id: id,
    name: name,
    isReadOnly: !allowEditableInputs,
    value: searchString,
    placeholder: placeholder,
    tabIndex: disableAccessibility ? -1 : 0,
    autoComplete: "off",
    "data-testid": "DatepickerInput",
    onFocus: handleOnFocus,
    onChange: handleOnChange
  })), !hideResetDateAddon && React.createElement(InputRightElement, Object.assign({}, clearDateRightAddon), React.createElement(IconButton, {
    "aria-label": "Clear Date",
    onClick: handleResetInputDate,
    bgColor: "transparent",
    variant: "outlined",
    icon: React.createElement(CloseIcon, Object.assign({}, resetDateIcon)),
    "data-testid": "clear-button-test-id",
    h: 9
  }))), showCalendarIcon && React.createElement(InputRightAddon, Object.assign({}, getStateStyle(inputComponentInputAddon, isActive)), React.createElement(Icon, Object.assign({
    as: iconComponent,
    //@ts-ignore
    onClick: handleOnFocus
  }, getStateStyle(inputComponentIcon, isActive)))));
});

var Month = function Month(_ref) {
  var year = _ref.year,
      month = _ref.month,
      isRangePicker = _ref.isRangePicker,
      handleResetEndDate = _ref.handleResetEndDate;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref2 = styles || {},
      monthContainer = _ref2.monthContainer,
      monthMonthLabel = _ref2.monthMonthLabel,
      monthWeekdayLabel = _ref2.monthWeekdayLabel,
      monthDayGrid = _ref2.monthDayGrid;

  var _useDatepickerContext = useDatepickerContext(),
      dayLabelFormat = _useDatepickerContext.dayLabelFormat,
      monthLabelFormat = _useDatepickerContext.monthLabelFormat,
      weekdayLabelFormat = _useDatepickerContext.weekdayLabelFormat,
      firstDayOfWeek = _useDatepickerContext.firstDayOfWeek;

  var _useMonth = useMonth({
    year: year,
    month: month,
    dayLabelFormat: dayLabelFormat,
    monthLabelFormat: monthLabelFormat,
    weekdayLabelFormat: weekdayLabelFormat,
    firstDayOfWeek: firstDayOfWeek
  }),
      days = _useMonth.days,
      weekdayLabels = _useMonth.weekdayLabels,
      monthLabel = _useMonth.monthLabel;

  var monthLabelFormatted = monthLabel.slice(0, 3);
  var yearLabel = monthLabel.slice(monthLabel.length - 4);
  return React.createElement(Box, Object.assign({}, monthContainer), isRangePicker && React.createElement(Flex, Object.assign({}, monthMonthLabel), React.createElement(Text, null, monthLabelFormatted + " " + yearLabel)), React.createElement(SimpleGrid, {
    columns: 7
  }, weekdayLabels.map(function (weekdayLabel) {
    return React.createElement(Flex, Object.assign({
      key: weekdayLabel
    }, monthWeekdayLabel), React.createElement(Text, null, weekdayLabel));
  })), React.createElement(SimpleGrid, Object.assign({}, monthDayGrid, {
    columns: 7
  }), days.map(function (day, index) {
    return typeof day === 'object' ? React.createElement(Day, {
      date: day.date,
      key: day.dayLabel + "-" + index,
      day: day.dayLabel,
      handleResetEndDate: handleResetEndDate
    }) : React.createElement("div", {
      key: index
    });
  })));
};

var _excluded$3 = ["ref"];

var useResponsivePicker = function useResponsivePicker() {
  var _useDatepickerContext = useDatepickerContext(),
      vertical = _useDatepickerContext.vertical;

  var isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  return {
    isMobile: isMobile,
    isVertical: vertical || isMobile
  };
};

var useDatePicker = function useDatePicker(_ref) {
  var ref = _ref.ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var _useResponsivePicker = useResponsivePicker(),
      isVertical = _useResponsivePicker.isVertical;

  var dp = useDatepicker(_extends({}, rest));
  useImperativeHandle(ref, function () {
    return {
      onDateSelect: function onDateSelect(date) {
        dp.onDateSelect(date);
      }
    };
  });
  var monthGridRef = useRef(null);

  var scrollTopToMonthGrid = function scrollTopToMonthGrid() {
    if (monthGridRef && monthGridRef.current && isVertical) {
      monthGridRef.current.scrollTop = 0;
    }
  };

  var _goToNextMonths = function _goToNextMonths() {
    dp.goToNextMonths();
    scrollTopToMonthGrid();
  };

  var _goToPreviousMonths = function _goToPreviousMonths() {
    dp.goToPreviousMonths();
    scrollTopToMonthGrid();
  };

  var _goToNextYear = function _goToNextYear() {
    dp.goToNextYear();
    scrollTopToMonthGrid();
  };

  var _goPreviousYear = function _goPreviousYear() {
    dp.goToPreviousYear();
    scrollTopToMonthGrid();
  };

  var _goToCurrentDay = function _goToCurrentDay() {
    var today = new Date();
    dp.goToDate(today);
    dp.onDateSelect(today);
  };

  return {
    dp: dp,
    _goToNextMonths: _goToNextMonths,
    _goToPreviousMonths: _goToPreviousMonths,
    _goToNextYear: _goToNextYear,
    _goPreviousYear: _goPreviousYear,
    _goToCurrentDay: _goToCurrentDay,
    monthGridRef: monthGridRef
  };
};

var textStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'block'
};
var stackStyles = {
  maxWidth: '100px',
  overflow: 'hidden'
};

var checkVertical = function checkVertical(obj, isVertical) {
  return isVertical ? obj : {};
};

var SelectedDate = function SelectedDate(_ref) {
  var isFocused = _ref.isFocused,
      date = _ref.date,
      initialDate = _ref.initialDate;

  var _useDatepickerContext = useDatepickerContext(),
      phrases = _useDatepickerContext.phrases,
      displayFormat = _useDatepickerContext.displayFormat;

  var _useResponsivePicker = useResponsivePicker(),
      isVertical = _useResponsivePicker.isVertical;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref2 = styles || {},
      selectDateContainer = _ref2.selectDateContainer,
      selectDateText = _ref2.selectDateText,
      selectDateDateText = _ref2.selectDateDateText;

  return React.createElement(Stack, Object.assign({}, checkVertical(stackStyles, isVertical), getStateStyle(selectDateContainer, isFocused)), React.createElement(Text, Object.assign({}, getStateStyle(selectDateText, isFocused)), initialDate ? phrases.datepickerStartDateLabel : phrases.datepickerEndDateLabel), React.createElement(Text, Object.assign({}, checkVertical(textStyles, isVertical), getStateStyle(selectDateDateText, isFocused)), getInputValue(date, displayFormat, phrases.datepickerStartDatePlaceholder)));
};

var Today = function Today(_ref) {
  var _goToCurrentDay = _ref._goToCurrentDay;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref2 = styles || {},
      todayButtonWrapper = _ref2.todayButtonWrapper,
      todayButtonText = _ref2.todayButtonText,
      todayButtonDivider = _ref2.todayButtonDivider;

  return React.createElement(React.Fragment, null, React.createElement(Divider, Object.assign({}, todayButtonDivider)), React.createElement(Flex, Object.assign({}, todayButtonWrapper), React.createElement(Text, Object.assign({}, todayButtonText, {
    onClick: _goToCurrentDay
  }), "HOY")));
};

var Months = function Months(_ref) {
  var monthGridRef = _ref.monthGridRef,
      _goToCurrentDay = _ref._goToCurrentDay,
      hoveredDate = _ref.hoveredDate,
      onDateHover = _ref.onDateHover,
      activeMonths = _ref.activeMonths;

  var _useDatepickerContext = useDatepickerContext(),
      isRangePicker = _useDatepickerContext.isRangePicker,
      handleResetEndDate = _useDatepickerContext.handleResetEndDate;

  var _useResponsivePicker = useResponsivePicker(),
      isVertical = _useResponsivePicker.isVertical;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref2 = styles || {},
      monthsWrapper = _ref2.monthsWrapper;

  return React.createElement(Stack, Object.assign({
    overflow: isVertical ? 'auto' : undefined,
    "data-testid": "MonthGrid",
    isInline: !isVertical,
    ref: monthGridRef,
    padding: 1
  }, monthsWrapper, {
    onMouseLeave: function onMouseLeave() {
      if (hoveredDate) {
        onDateHover(null);
      }
    }
  }), activeMonths.map(function (month) {
    return React.createElement(Flex, {
      flexDir: 'column',
      key: "month-" + month.year + "-" + month.month,
      w: '100%'
    }, React.createElement(Month, {
      year: month.year,
      month: month.month,
      isRangePicker: isRangePicker,
      handleResetEndDate: handleResetEndDate
    }), isRangePicker && React.createElement(Today, {
      _goToCurrentDay: _goToCurrentDay
    }));
  }));
};

var SeletedDates = function SeletedDates(_ref) {
  var focusedInput = _ref.focusedInput;

  var _useDatepickerContext = useDatepickerContext(),
      startDate = _useDatepickerContext.startDate,
      endDate = _useDatepickerContext.endDate;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref2 = styles || {},
      arrowIcon = _ref2.arrowIcon;

  return React.createElement(Box, null, React.createElement(HStack, {
    "data-testid": "SelectedDatesGrid"
  }, React.createElement(SelectedDate, {
    date: startDate,
    isFocused: focusedInput === START_DATE,
    initialDate: true
  }), React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center"
  }, React.createElement(ArrowForwardIcon, Object.assign({}, arrowIcon))), React.createElement(SelectedDate, {
    date: endDate,
    isFocused: focusedInput === END_DATE,
    initialDate: false
  })));
};

var useDatePickerFooter = function useDatePickerFooter() {
  var _useDatepickerContext = useDatepickerContext(),
      activeMonths = _useDatepickerContext.activeMonths,
      dayLabelFormat = _useDatepickerContext.dayLabelFormat,
      monthLabelFormat = _useDatepickerContext.monthLabelFormat,
      weekdayLabelFormat = _useDatepickerContext.weekdayLabelFormat;

  var getActiveMonth = function getActiveMonth() {
    if (!activeMonths || typeof activeMonths !== 'object') return [];
    var dataValues = Object.values(activeMonths);
    if (!(dataValues != null && dataValues.length)) return [];
    return dataValues[0] || [];
  };

  var activeMonth = getActiveMonth();
  useEffect(function () {
    getActiveMonth();
  }, []);

  var _useMonth = useMonth({
    year: activeMonth.year,
    month: activeMonth.month,
    dayLabelFormat: dayLabelFormat,
    monthLabelFormat: monthLabelFormat,
    weekdayLabelFormat: weekdayLabelFormat
  }),
      monthLabel = _useMonth.monthLabel;

  var monthLabelFormatted = monthLabel.slice(0, 3);
  var yearLabel = monthLabel.slice(monthLabel.length - 4);
  return {
    monthLabelFormatted: monthLabelFormatted,
    yearLabel: yearLabel
  };
};

var DatePickerFooter = function DatePickerFooter(_ref) {
  var _goPreviousYear = _ref._goPreviousYear,
      _goToNextMonths = _ref._goToNextMonths,
      _goToNextYear = _ref._goToNextYear,
      _goToPreviousMonths = _ref._goToPreviousMonths;

  var _useDatepickerContext = useDatepickerContext(),
      showResetDates = _useDatepickerContext.showResetDates,
      isRangePicker = _useDatepickerContext.isRangePicker;

  var _useResponsivePicker = useResponsivePicker(),
      isVertical = _useResponsivePicker.isVertical;

  var _useDatePickerFooter = useDatePickerFooter(),
      monthLabelFormatted = _useDatePickerFooter.monthLabelFormatted,
      yearLabel = _useDatePickerFooter.yearLabel;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref2 = styles || {},
      datepickerFooter = _ref2.datepickerFooter,
      actionButton = _ref2.actionButton,
      monthMonthLabel = _ref2.monthMonthLabel;

  return React.createElement(Flex, Object.assign({
    justifyContent: showResetDates ? 'space-between' : 'center'
  }, datepickerFooter), React.createElement(Flex, null, React.createElement(ActionButton, Object.assign({
    direction: isVertical ? 'up' : 'left',
    onClick: _goPreviousYear,
    "aria-label": "Previous year",
    doubleArrowIcon: true,
    fontSize: "10px"
  }, actionButton)), React.createElement(ActionButton, Object.assign({
    direction: isVertical ? 'up' : 'left',
    onClick: _goToPreviousMonths,
    "aria-label": "Previous month"
  }, actionButton))), isRangePicker ? React.createElement(Spacer, null) : React.createElement(Flex, Object.assign({}, monthMonthLabel), React.createElement(Text, {
    "data-testid": "month-label-test-id"
  }, monthLabelFormatted + " " + yearLabel)), React.createElement(Flex, null, React.createElement(ActionButton, Object.assign({
    direction: isVertical ? 'down' : 'right',
    onClick: _goToNextMonths,
    "aria-label": "Next month"
  }, actionButton)), React.createElement(ActionButton, Object.assign({
    direction: isVertical ? 'down' : 'right',
    onClick: _goToNextYear,
    "aria-label": "Next year",
    doubleArrowIcon: true,
    fontSize: "10px"
  }, actionButton))));
};

var Datepicker = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var changeActiveMonthOnSelect = props.changeActiveMonthOnSelect,
      _props$displayFormat = props.displayFormat,
      displayFormat = _props$displayFormat === void 0 ? defaultDisplayFormat : _props$displayFormat,
      _props$endDate = props.endDate,
      endDate = _props$endDate === void 0 ? null : _props$endDate,
      _props$exactMinBookin = props.exactMinBookingDays,
      exactMinBookingDays = _props$exactMinBookin === void 0 ? false : _props$exactMinBookin,
      firstDayOfWeek = props.firstDayOfWeek,
      _props$focusedInput = props.focusedInput,
      focusedInput = _props$focusedInput === void 0 ? null : _props$focusedInput,
      onFocus = props.onFocus,
      handleResetEndDate = props.handleResetEndDate,
      initialVisibleMonth = props.initialVisibleMonth,
      _props$isDateBlocked = props.isDateBlocked,
      isDateBlocked = _props$isDateBlocked === void 0 ? function () {
    return false;
  } : _props$isDateBlocked,
      isRangePicker = props.isRangePicker,
      maxBookingDate = props.maxBookingDate,
      minBookingDate = props.minBookingDate,
      _props$minBookingDays = props.minBookingDays,
      minBookingDays = _props$minBookingDays === void 0 ? 1 : _props$minBookingDays,
      _props$numberOfMonths = props.numberOfMonths,
      numberOfMonths = _props$numberOfMonths === void 0 ? 2 : _props$numberOfMonths,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
      _props$onDatesChange = props.onDatesChange,
      onDatesChange = _props$onDatesChange === void 0 ? function () {} : _props$onDatesChange,
      onDayRender = props.onDayRender,
      overwriteDefaultStyles = props.overwriteDefaultStyles,
      _props$phrases = props.phrases,
      phrases = _props$phrases === void 0 ? datepickerPhrases : _props$phrases,
      _props$showClose = props.showClose,
      showClose = _props$showClose === void 0 ? true : _props$showClose,
      _props$showResetDates = props.showResetDates,
      showResetDates = _props$showResetDates === void 0 ? false : _props$showResetDates,
      _props$showSelectedDa = props.showSelectedDates,
      showSelectedDates = _props$showSelectedDa === void 0 ? true : _props$showSelectedDa,
      _props$startDate = props.startDate,
      startDate = _props$startDate === void 0 ? null : _props$startDate,
      customStyles = props.styles,
      _props$unavailableDat = props.unavailableDates,
      unavailableDates = _props$unavailableDat === void 0 ? [] : _props$unavailableDat,
      vertical = props.vertical;

  var _useDatePicker = useDatePicker({
    ref: ref,
    changeActiveMonthOnSelect: changeActiveMonthOnSelect,
    endDate: endDate,
    exactMinBookingDays: exactMinBookingDays,
    firstDayOfWeek: firstDayOfWeek,
    focusedInput: focusedInput,
    initialVisibleMonth: initialVisibleMonth,
    isDateBlocked: isDateBlocked,
    maxBookingDate: maxBookingDate,
    minBookingDate: minBookingDate,
    minBookingDays: minBookingDays,
    numberOfMonths: numberOfMonths,
    onDatesChange: onDatesChange,
    startDate: startDate,
    unavailableDates: unavailableDates
  }),
      dp = _useDatePicker.dp,
      _goPreviousYear = _useDatePicker._goPreviousYear,
      _goToCurrentDay = _useDatePicker._goToCurrentDay,
      _goToNextMonths = _useDatePicker._goToNextMonths,
      _goToNextYear = _useDatePicker._goToNextYear,
      _goToPreviousMonths = _useDatePicker._goToPreviousMonths,
      monthGridRef = _useDatePicker.monthGridRef;

  var _useResponsivePicker = useResponsivePicker(),
      isMobile = _useResponsivePicker.isMobile;

  var _useContext = useContext(StylesContext),
      styles = _useContext.styles;

  var _ref = styles || {},
      datepickerContainer = _ref.datepickerContainer,
      monthTopDivider = _ref.monthTopDivider;

  return React.createElement(StylesProvider, {
    styles: customStyles,
    overwriteDefaultStyles: overwriteDefaultStyles
  }, React.createElement(DatepickerProvider, Object.assign({
    vertical: vertical,
    dayLabelFormat: function dayLabelFormat(date) {
      return format(date, 'dd', {
        locale: es
      });
    },
    weekdayLabelFormat: function weekdayLabelFormat(date) {
      return format(date, 'eeeeee', {
        locale: es
      });
    },
    monthLabelFormat: function monthLabelFormat(date) {
      return format(date, 'MMMM yyyy', {
        locale: es
      });
    },
    displayFormat: displayFormat,
    endDate: endDate,
    phrases: phrases,
    startDate: startDate,
    onDayRender: onDayRender,
    showResetDates: showResetDates,
    isRangePicker: isRangePicker,
    handleResetEndDate: handleResetEndDate
  }, dp), React.createElement(Box, Object.assign({
    minWidth: !vertical ? '500px' : 'unset',
    maxWidth: isRangePicker && isMobile ? 'fit-content' : 'unset',
    onFocus: onFocus
  }, datepickerContainer), showClose && React.createElement(CloseButton, {
    onClick: onClose
  }), showSelectedDates && React.createElement(SeletedDates, {
    focusedInput: focusedInput
  }), React.createElement(Box, {
    position: "relative"
  }, React.createElement(DatePickerFooter, {
    _goPreviousYear: _goPreviousYear,
    _goToNextMonths: _goToNextMonths,
    _goToNextYear: _goToNextYear,
    _goToPreviousMonths: _goToPreviousMonths
  }), React.createElement(Divider, Object.assign({}, monthTopDivider)), React.createElement(Months, {
    monthGridRef: monthGridRef,
    _goToCurrentDay: _goToCurrentDay,
    hoveredDate: dp.hoveredDate,
    onDateHover: dp.onDateHover,
    activeMonths: dp.activeMonths
  }), !isRangePicker && React.createElement(Today, {
    _goToCurrentDay: _goToCurrentDay
  })))));
});

var errorYearMsg = function errorYearMsg(year) {
  return "El a\xF1o no puede ser mayor de " + year;
};

var errorRangeMsg = "La fecha de fin debe ser mayor o igual que la fecha de inicio";

var useDate = function useDate(_ref) {
  var startDateProp = _ref.startDateProp,
      endDateProp = _ref.endDateProp,
      onFocusChange = _ref.onFocusChange,
      focusedInputProp = _ref.focusedInputProp,
      onDatesChange = _ref.onDatesChange,
      onClose = _ref.onClose,
      errors = _ref.errors,
      showYearError = _ref.showYearError,
      showRangeError = _ref.showRangeError,
      maxYear = _ref.maxYear;

  var _useState = useState(null),
      startDate = _useState[0],
      setStartDate = _useState[1];

  var _useState2 = useState(null),
      endDate = _useState2[0],
      setEndDate = _useState2[1];

  var _useState3 = useState(undefined),
      errorRange = _useState3[0],
      setErrorRange = _useState3[1];

  var _useState4 = useState({
    start: undefined,
    end: undefined
  }),
      errorYear = _useState4[0],
      setErrorYear = _useState4[1];

  var _useState5 = useState(formatDateToISO(startDate)),
      startFormated = _useState5[0],
      setStartFormated = _useState5[1];

  var _useState6 = useState(formatDateToISO(endDate)),
      endFormated = _useState6[0],
      setEndFormated = _useState6[1];

  var _useState7 = useState(focusedInputProp),
      focusedInput = _useState7[0],
      setFocusedInput = _useState7[1];

  var datepickerWrapperRef = useRef(null);
  useEffect(function () {
    var startDateFormated = startDateProp != undefined ? formatValidYear(startDateProp, maxYear) : null;
    var endDateFormated = endDateProp != undefined ? formatValidYear(endDateProp, maxYear) : null;
    var startHasError = errorYear.start != undefined || (startDateFormated && startDateProp ? !dateIsEqual(startDateProp, startDateFormated) : false);
    var endHasError = errorYear.end != undefined || (endDateProp && endDateFormated ? !dateIsEqual(endDateProp, endDateFormated) : false);
    setYearErrors(startHasError, endHasError);
    setStartDate(startDateFormated || null);

    if (!validEndDate(startDateFormated, endDateFormated)) {
      setEndDate(startDateFormated || null);
      setRangeErrors();
    } else {
      setEndDate(endDateFormated || null);
    }
  }, [startDateProp, endDateProp]);
  useEffect(function () {
    setStartFormated(formatDateToISO(startDate));

    if (!validEndDate(startDate, endDate)) {
      setEndFormated(formatDateToISO(startDate));
      setRangeErrors();
    } else {
      setEndFormated(formatDateToISO(endDate));
    }
  }, [startDate, endDate]);
  useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('click', onClickOutsideHandler);
    }

    return function () {
      window.removeEventListener('click', onClickOutsideHandler);
    };
  });

  var handleOnFocusChange = function handleOnFocusChange(_focusedInput) {
    setFocusedInput(_focusedInput);
    onFocusChange(_focusedInput);
  };

  var onClickOutsideHandler = function onClickOutsideHandler(event) {
    if (focusedInput !== null && datepickerWrapperRef && datepickerWrapperRef.current && // @ts-ignore
    !datepickerWrapperRef.current.contains(event.target)) {
      handleOnFocusChange(null);
    }
  };

  var handleOnDatesChange = function handleOnDatesChange(data) {
    var startDateFormated = formatValidYear(data.startDate, maxYear);
    var endDateFormated = formatValidYear(data.endDate, maxYear);
    var startHasError = startDateFormated && data.startDate ? !dateIsEqual(data.startDate, startDateFormated) : false;
    var endHasError = data.endDate && endDateFormated ? !dateIsEqual(data.endDate, endDateFormated) : false;
    setYearErrors(startHasError, endHasError);

    if (validEndDate(data.startDate, data.endDate)) {
      clearRangeErrors();
    } else {
      endDateFormated = startDateFormated;
      setRangeErrors();
    }

    setStartDate(startDateFormated);
    setEndDate(endDateFormated);
    setFocusedInput(data.focusedInput);
    onDatesChange({
      startDate: startDateFormated,
      endDate: endDateFormated,
      focusedInput: focusedInput
    });
  };

  var hasCorrectFormat = function hasCorrectFormat(date) {
    var year = date && date.getFullYear();
    return year && year.toString().length === 4;
  };

  var changeDate = function changeDate(isStart, value) {
    var year = value && value.getFullYear();
    if (year && year.toString().length < 4) value == null ? void 0 : value.setUTCFullYear(year + 2000);
    hasCorrectFormat(value);
    isStart ? handleOnDatesChange({
      startDate: value,
      endDate: endDate,
      focusedInput: focusedInput
    }) : handleOnDatesChange({
      endDate: value,
      startDate: startDate,
      focusedInput: focusedInput
    });
  };

  var bothDateFilled = function bothDateFilled(startDate, endDate) {
    return startDate && endDate;
  };

  var dateRangeIsCorrect = function dateRangeIsCorrect(startDate, endDate) {
    return startDate && endDate && startDate <= endDate;
  };

  var validEndDate = function validEndDate(startDate, endDate) {
    return !bothDateFilled(startDate, endDate) || dateRangeIsCorrect(startDate, endDate);
  };

  var setRangeErrors = function setRangeErrors() {
    return showRangeError && setErrorRange((errors == null ? void 0 : errors.customRangeError) || errorRangeMsg);
  };

  var clearRangeErrors = function clearRangeErrors() {
    return setErrorRange(undefined);
  };

  var getYearErrorMsg = function getYearErrorMsg(hasError) {
    return hasError ? (errors == null ? void 0 : errors.customYearError) || errorYearMsg(maxYear) : undefined;
  };

  var setYearErrors = function setYearErrors(startError, endError) {
    showYearError && setErrorYear({
      start: getYearErrorMsg(startError),
      end: getYearErrorMsg(endError)
    });
  };

  var checkId = function checkId(id, propId, defaultId) {
    return id === propId || id === defaultId;
  };

  return {
    endDate: endDate,
    startDate: startDate,
    focusedInput: focusedInput,
    datepickerWrapperRef: datepickerWrapperRef,
    onClickOutsideHandler: onClickOutsideHandler,
    handleOnDatesChange: handleOnDatesChange,
    handleOnFocusChange: handleOnFocusChange,
    handleResetStartDate: function handleResetStartDate() {
      var hasEndError = errorYear.end ? true : false;
      clearRangeErrors();
      setYearErrors(false, hasEndError);
      setStartDate(null);
      handleOnDatesChange({
        startDate: null,
        endDate: endDate
      });
    },
    handleResetEndDate: function handleResetEndDate(currentDate) {
      var hasStartError = errorYear.start ? true : false;
      clearRangeErrors();
      setYearErrors(hasStartError, false);
      setEndDate(null);
      setStartDate(currentDate || startDate);
      handleOnDatesChange({
        startDate: currentDate || startDate,
        endDate: null
      });
      handleOnFocusChange('endDate');
    },
    handleOnClose: function handleOnClose() {
      handleOnFocusChange(null);
      onClose();
    },
    hasCorrectFormat: hasCorrectFormat,
    changeDate: changeDate,
    checkId: checkId,
    errorRange: errorRange,
    startFormated: startFormated,
    endFormated: endFormated,
    errorYear: errorYear
  };
};

var useDatePicker$1 = function useDatePicker() {
  var datepickerRef = useRef(null);
  return {
    datepickerRef: datepickerRef,
    handleInputChange: function handleInputChange(date) {
      if (datepickerRef && datepickerRef.current && datepickerRef.current.onDateSelect) {
        datepickerRef.current.onDateSelect(date);
      }
    }
  };
};

var _excluded$4 = ["allowEditableInputs", "dateFormat", "error", "isActive", "formControlProps", "handleResetDate", "hideResetDateAddon", "id", "label", "name", "phrase", "ref", "showCalendarIcon", "stackProps", "onChange", "size"];

var StackInput = function StackInput(_ref) {
  var allowEditableInputs = _ref.allowEditableInputs,
      dateFormat = _ref.dateFormat,
      error = _ref.error,
      isActive = _ref.isActive,
      formControlProps = _ref.formControlProps,
      handleResetDate = _ref.handleResetDate,
      hideResetDateAddon = _ref.hideResetDateAddon,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      phrase = _ref.phrase,
      ref = _ref.ref,
      showCalendarIcon = _ref.showCalendarIcon,
      stackProps = _ref.stackProps,
      onChange = _ref.onChange,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  var _useContext = useContext(StylesContext),
      _useContext$styles = _useContext.styles,
      formLabel = _useContext$styles.formLabel,
      formErrorMessage = _useContext$styles.formErrorMessage;

  var formLabelProps = _extends({
    fontSize: size
  }, formLabel);

  var formErrorMessageProps = _extends({
    fontSize: size
  }, formErrorMessage);

  return React.createElement(Stack, Object.assign({
    direction: "column",
    maxW: 'unset'
  }, stackProps), React.createElement(FormControl, Object.assign({
    isInvalid: !!error
  }, formControlProps), label && React.createElement(FormLabel, Object.assign({}, formLabelProps), label), React.createElement(Input, Object.assign({
    allowEditableInputs: allowEditableInputs,
    "aria-label": phrase,
    dateFormat: dateFormat,
    handleResetDate: handleResetDate,
    hideResetDateAddon: hideResetDateAddon,
    id: id,
    isActive: isActive,
    name: name,
    ref: ref,
    showCalendarIcon: showCalendarIcon,
    onChange: onChange,
    size: size
  }, rest)), React.createElement(FormErrorMessage, Object.assign({}, formErrorMessageProps), error)));
};

var DateRangeInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var endDateProp = props.endDate,
      startDateProp = props.startDate,
      _props$focusedInput = props.focusedInput,
      focusedInputProp = _props$focusedInput === void 0 ? null : _props$focusedInput,
      _props$displayFormat = props.displayFormat,
      displayFormat = _props$displayFormat === void 0 ? defaultDisplayFormat : _props$displayFormat,
      _props$endShowCalenda = props.endShowCalendarIcon,
      endShowCalendarIcon = _props$endShowCalenda === void 0 ? true : _props$endShowCalenda,
      _props$isDateBlocked = props.isDateBlocked,
      isDateBlocked = _props$isDateBlocked === void 0 ? function () {
    return false;
  } : _props$isDateBlocked,
      _props$minBookingDays = props.minBookingDays,
      minBookingDays = _props$minBookingDays === void 0 ? 1 : _props$minBookingDays,
      _props$phrases = props.phrases,
      phrases = _props$phrases === void 0 ? dateRangeInputPhrases : _props$phrases,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$showClose = props.showClose,
      showClose = _props$showClose === void 0 ? true : _props$showClose,
      _props$showDivider = props.showDivider,
      showDivider = _props$showDivider === void 0 ? false : _props$showDivider,
      showResetDates = props.showResetDates,
      _props$showSelectedDa = props.showSelectedDates,
      showSelectedDates = _props$showSelectedDa === void 0 ? true : _props$showSelectedDa,
      _props$startShowCalen = props.startShowCalendarIcon,
      startShowCalendarIcon = _props$startShowCalen === void 0 ? true : _props$startShowCalen,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
      _props$onDatesChange = props.onDatesChange,
      onDatesChange = _props$onDatesChange === void 0 ? function () {} : _props$onDatesChange,
      _props$onFocusChange = props.onFocusChange,
      onFocusChange = _props$onFocusChange === void 0 ? function () {} : _props$onFocusChange,
      customStyles = props.styles,
      overwriteDefaultStyles = props.overwriteDefaultStyles,
      startIcon = props.startIcon,
      startId = props.startId,
      startName = props.startName,
      startPlaceholder = props.startPlaceholder,
      startRef = props.startRef,
      endId = props.endId,
      endName = props.endName,
      endRef = props.endRef,
      endIcon = props.endIcon,
      endPlaceholder = props.endPlaceholder,
      changeActiveMonthOnSelect = props.changeActiveMonthOnSelect,
      dayLabelFormat = props.dayLabelFormat,
      exactMinBookingDays = props.exactMinBookingDays,
      firstDayOfWeek = props.firstDayOfWeek,
      initialVisibleMonth = props.initialVisibleMonth,
      maxBookingDate = props.maxBookingDate,
      minBookingDate = props.minBookingDate,
      numberOfMonths = props.numberOfMonths,
      onDayRender = props.onDayRender,
      unavailableDates = props.unavailableDates,
      _props$allowEditableI = props.allowEditableInputs,
      allowEditableInputs = _props$allowEditableI === void 0 ? true : _props$allowEditableI,
      errors = props.errors,
      labelFrom = props.labelFrom,
      labelTo = props.labelTo,
      hideResetStartDateAddon = props.hideResetStartDateAddon,
      hideResetEndDateAddon = props.hideResetEndDateAddon,
      verticalAlignInputs = props.verticalAlignInputs,
      startStackInputProps = props.startStackInputProps,
      endStackInputProps = props.endStackInputProps,
      size = props.size,
      _props$showYearError = props.showYearError,
      showYearError = _props$showYearError === void 0 ? true : _props$showYearError,
      _props$showRangeError = props.showRangeError,
      showRangeError = _props$showRangeError === void 0 ? true : _props$showRangeError,
      _props$maxYear = props.maxYear,
      maxYear = _props$maxYear === void 0 ? defaultMaxYear : _props$maxYear;

  var _useDate = useDate({
    endDateProp: endDateProp,
    startDateProp: startDateProp,
    focusedInputProp: focusedInputProp,
    onFocusChange: onFocusChange,
    onDatesChange: onDatesChange,
    onClose: onClose,
    errors: errors,
    showYearError: showYearError,
    showRangeError: showRangeError,
    maxYear: maxYear
  }),
      endDate = _useDate.endDate,
      startDate = _useDate.startDate,
      focusedInput = _useDate.focusedInput,
      datepickerWrapperRef = _useDate.datepickerWrapperRef,
      handleOnDatesChange = _useDate.handleOnDatesChange,
      handleOnFocusChange = _useDate.handleOnFocusChange,
      handleResetEndDate = _useDate.handleResetEndDate,
      handleResetStartDate = _useDate.handleResetStartDate,
      handleOnClose = _useDate.handleOnClose,
      changeDate = _useDate.changeDate,
      checkId = _useDate.checkId,
      errorRange = _useDate.errorRange,
      startFormated = _useDate.startFormated,
      endFormated = _useDate.endFormated,
      errorYear = _useDate.errorYear;

  var maxDate = maxYear + "-12-31";

  var _useDatePicker = useDatePicker$1(),
      datepickerRef = _useDatePicker.datepickerRef;

  var _useContext = useContext(StylesContext),
      _useContext$styles = _useContext.styles,
      dateRangeInputContainer = _useContext$styles.dateRangeInputContainer,
      dateRangeInputDivider = _useContext$styles.dateRangeInputDivider;

  var isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  var vertical = props.vertical || isMobile;

  var handleOnChange = function handleOnChange(e) {
    var id = e && e.target && e.target.id;
    var isStartDate = checkId(id, startId, START_DATE$1);
    var isEndDate = checkId(id, endId, END_DATE$1);

    if (isStartDate || isEndDate) {
      var date = id && e.target.value && new Date(e.target.value);
      changeDate(isStartDate, date);
    }
  };

  return React.createElement(StylesProvider, {
    styles: customStyles,
    overwriteDefaultStyles: overwriteDefaultStyles
  }, React.createElement(Box, {
    position: "relative",
    ref: datepickerWrapperRef
  }, React.createElement(Stack, Object.assign({
    isInline: !verticalAlignInputs && !isMobile
  }, dateRangeInputContainer, {
    "data-testid": "DateRangeInputGrid",
    divider: showDivider ? React.createElement(StackDivider, Object.assign({}, dateRangeInputDivider)) : undefined,
    //@ts-ignore
    ref: ref
  }), React.createElement(StackInput, Object.assign({
    type: "date",
    allowEditableInputs: allowEditableInputs,
    "aria-label": phrases.startDateAriaLabel,
    "data-testid": "startDate-input-test-id",
    dateFormat: displayFormat,
    error: (errors == null ? void 0 : errors.start) || errorYear.start,
    handleOnFocusChange: handleOnClose,
    handleResetDate: handleResetStartDate,
    hideResetDateAddon: hideResetStartDateAddon,
    iconComponent: startIcon,
    id: startId || START_DATE$1,
    isActive: focusedInput === START_DATE$1,
    label: labelFrom,
    name: startName || START_DATE$1,
    onBlur: function onBlur(e) {
      return handleOnChange(e);
    },
    onClick: function onClick() {
      return handleOnFocusChange(START_DATE$1);
    },
    placeholder: startPlaceholder || phrases.startDatePlaceholder,
    ref: startRef,
    showCalendarIcon: startShowCalendarIcon,
    value: startFormated,
    size: size,
    max: maxDate,
    sx: {
      '::-webkit-calendar-picker-indicator': {
        display: 'none'
      }
    }
  }, startStackInputProps)), React.createElement(StackInput, Object.assign({
    type: "date",
    allowEditableInputs: allowEditableInputs,
    "aria-label": phrases.endDateAriaLabel,
    "data-testid": "endDate-input-test-id",
    dateFormat: displayFormat,
    error: (errors == null ? void 0 : errors.end) || errorRange || errorYear.end,
    handleOnFocusChange: handleOnClose,
    handleResetDate: handleResetEndDate,
    hideResetDateAddon: hideResetEndDateAddon,
    iconComponent: endIcon,
    id: endId || END_DATE$1,
    isActive: focusedInput === END_DATE$1,
    label: labelTo,
    name: endName || END_DATE$1,
    onBlur: function onBlur(e) {
      return handleOnChange(e);
    },
    onClick: function onClick() {
      return handleOnFocusChange(!startDate ? START_DATE$1 : END_DATE$1);
    },
    placeholder: endPlaceholder || phrases.endDatePlaceholder,
    ref: endRef,
    showCalendarIcon: endShowCalendarIcon,
    value: endFormated,
    size: size,
    max: maxDate,
    sx: {
      '::-webkit-calendar-picker-indicator': {
        display: 'none'
      }
    }
  }, endStackInputProps))), React.createElement(Box, {
    position: "absolute",
    top: placement === 'top' ? undefined : vertical ? '100px' : '80px',
    bottom: placement === 'bottom' ? undefined : vertical ? '100px' : '45px'
  }, focusedInput !== null && React.createElement(Box, null, React.createElement(Datepicker, {
    ref: datepickerRef,
    startDate: startDate,
    endDate: endDate,
    focusedInput: focusedInput,
    onClose: handleOnClose,
    onDatesChange: handleOnDatesChange,
    changeActiveMonthOnSelect: changeActiveMonthOnSelect,
    dayLabelFormat: dayLabelFormat,
    exactMinBookingDays: exactMinBookingDays,
    firstDayOfWeek: firstDayOfWeek,
    initialVisibleMonth: initialVisibleMonth,
    isDateBlocked: isDateBlocked,
    maxBookingDate: maxBookingDate,
    minBookingDate: minBookingDate,
    minBookingDays: minBookingDays,
    monthLabelFormat: function monthLabelFormat(date) {
      return format(date, 'MMMM yyyy', {
        locale: es
      });
    },
    numberOfMonths: vertical ? 1 : numberOfMonths,
    onDayRender: onDayRender,
    phrases: phrases,
    unavailableDates: unavailableDates,
    displayFormat: displayFormat,
    showClose: showClose,
    showResetDates: showResetDates,
    showSelectedDates: showSelectedDates,
    vertical: vertical,
    weekdayLabelFormat: function weekdayLabelFormat(date) {
      return format(date, 'eeeeee', {
        locale: es
      });
    },
    isRangePicker: true,
    handleResetEndDate: handleResetEndDate
  })))));
});

var useDate$1 = function useDate(_ref) {
  var value = _ref.value,
      dateProp = _ref.dateProp,
      onFocusChange = _ref.onFocusChange,
      onChange = _ref.onChange,
      showDatepickerProp = _ref.showDatepickerProp,
      format = _ref.format,
      onClose = _ref.onClose;

  var _useState = useState(value ? new Date(value) : dateProp),
      date = _useState[0],
      setDate = _useState[1];

  var _useState2 = useState(showDatepickerProp),
      showDatepicker = _useState2[0],
      setShowDatepicker = _useState2[1];

  var _useState3 = useState(null),
      focusedInput = _useState3[0],
      setFocusedInput = _useState3[1];

  var datepickerRef = useRef(null);
  var datepickerWrapperRef = useRef(null);
  useEffect(function () {
    setDate(value ? new Date(value) : null);
  }, [value]);
  useEffect(function () {
    onFocusChange(showDatepicker);
  }, [onFocusChange, showDatepicker]);

  var hasCorrectFormat = function hasCorrectFormat(date) {
    var year = date && date.getFullYear();
    return year && year.toString().length === 4;
  };

  var changeDate = function changeDate(inputDate) {
    var year = inputDate && inputDate.getFullYear();
    if (year && year.toString().length < 4) inputDate == null ? void 0 : inputDate.setUTCFullYear(year + 2000);
    hasCorrectFormat(inputDate);
    handleOnDatesChange({
      startDate: inputDate,
      endDate: null,
      focusedInput: null
    });
  };

  useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('click', onClickOutsideHandler);
    }

    return function () {
      window.removeEventListener('click', onClickOutsideHandler);
    };
  }, []);

  var handleOnFocusChange = function handleOnFocusChange(show) {
    setShowDatepicker(show);
    setFocusedInput(show ? START_DATE$1 : null);
  };

  var onClickOutsideHandler = function onClickOutsideHandler(event) {
    if (datepickerWrapperRef && datepickerWrapperRef.current && // @ts-ignore
    !datepickerWrapperRef.current.contains(event.target)) {
      handleOnFocusChange(false);
    }
  };

  var handleInputChange = function handleInputChange(date) {
    changeDate(date); // TODO - Con onDateSelect cambia el valor de DatePicker
    // if (
    //   datepickerRef &&
    //   datepickerRef.current &&
    //   datepickerRef.current.onDateSelect
    // ) {
    // }
  };

  var handleOnDatesChange = function handleOnDatesChange(data) {
    var _data$startDate;

    setFocusedInput(data.focusedInput);
    setDate(data.startDate);
    onChange(formatDateDatepicker((_data$startDate = data.startDate) == null ? void 0 : _data$startDate.toDateString(), format));
  };

  return {
    date: date,
    setDate: setDate,
    showDatepicker: showDatepicker,
    datepickerRef: datepickerRef,
    datepickerWrapperRef: datepickerWrapperRef,
    focusedInput: focusedInput,
    setFocusedInput: setFocusedInput,
    handleResetDate: function handleResetDate() {
      setDate(null);
      onChange(null);
    },
    handleDatepickerClose: function handleDatepickerClose() {
      handleOnFocusChange(false);
      onClose();
    },
    handleOnFocusChange: handleOnFocusChange,
    handleInputChange: handleInputChange,

    /**
    *
    * @param data
    * @function setDate setea la fecha en el estado interno del DateSinglePicker
    * @function onChange formateamos la fecha usando el format(sino por defecto es yyyy-MM-dd) para pasarla a un string
    */
    handleOnDatesChange: handleOnDatesChange
  };
};

var DateSingleInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$allowEditableInp = _ref.allowEditableInputs,
      allowEditableInputs = _ref$allowEditableInp === void 0 ? true : _ref$allowEditableInp,
      changeActiveMonthOnSelect = _ref.changeActiveMonthOnSelect,
      _ref$date = _ref.date,
      dateProp = _ref$date === void 0 ? null : _ref$date,
      datePickerBoxProps = _ref.datePickerBoxProps,
      dayLabelFormat = _ref.dayLabelFormat,
      _ref$displayFormat = _ref.displayFormat,
      displayFormat = _ref$displayFormat === void 0 ? defaultDisplayFormat : _ref$displayFormat,
      error = _ref.error,
      firstDayOfWeek = _ref.firstDayOfWeek,
      format$1 = _ref.format,
      formErrorMessageProps = _ref.formErrorMessageProps,
      formLabelProps = _ref.formLabelProps,
      hideResetDateAddon = _ref.hideResetDateAddon,
      iconComponent = _ref.iconComponent,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'startDate' : _ref$id,
      initialVisibleMonth = _ref.initialVisibleMonth,
      inputProps = _ref.inputProps,
      _ref$isDateBlocked = _ref.isDateBlocked,
      isDateBlocked = _ref$isDateBlocked === void 0 ? function () {
    return false;
  } : _ref$isDateBlocked,
      label = _ref.label,
      maxBookingDate = _ref.maxBookingDate,
      _ref$maxYear = _ref.maxYear,
      maxYear = _ref$maxYear === void 0 ? defaultMaxYear : _ref$maxYear,
      minBookingDate = _ref.minBookingDate,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'startDate' : _ref$name,
      _ref$numberOfMonths = _ref.numberOfMonths,
      numberOfMonths = _ref$numberOfMonths === void 0 ? 1 : _ref$numberOfMonths,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      onDayRender = _ref.onDayRender,
      _ref$onFocusChange = _ref.onFocusChange,
      onFocusChange = _ref$onFocusChange === void 0 ? function () {} : _ref$onFocusChange,
      overwriteDefaultStyles = _ref.overwriteDefaultStyles,
      _ref$phrases = _ref.phrases,
      phrases = _ref$phrases === void 0 ? dateSingleInputPhrases : _ref$phrases,
      placeholder = _ref.placeholder,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$showCalendarIcon = _ref.showCalendarIcon,
      showCalendarIcon = _ref$showCalendarIcon === void 0 ? true : _ref$showCalendarIcon,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      _ref$showDatepicker = _ref.showDatepicker,
      showDatepickerProp = _ref$showDatepicker === void 0 ? false : _ref$showDatepicker,
      showResetDate = _ref.showResetDate,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      styles = _ref.styles,
      _ref$unavailableDates = _ref.unavailableDates,
      unavailableDates = _ref$unavailableDates === void 0 ? [] : _ref$unavailableDates,
      value = _ref.value,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical;

  var _useDate = useDate$1({
    dateProp: dateProp,
    onChange: onChange,
    onFocusChange: onFocusChange,
    value: value,
    format: format$1,
    showDatepickerProp: showDatepickerProp,
    onClose: onClose
  }),
      date = _useDate.date,
      handleInputChange = _useDate.handleInputChange,
      handleOnDatesChange = _useDate.handleOnDatesChange,
      handleResetDate = _useDate.handleResetDate,
      datepickerRef = _useDate.datepickerRef,
      datepickerWrapperRef = _useDate.datepickerWrapperRef,
      focusedInput = _useDate.focusedInput,
      showDatepicker = _useDate.showDatepicker,
      handleOnFocusChange = _useDate.handleOnFocusChange,
      handleDatepickerClose = _useDate.handleDatepickerClose,
      setFocusedInput = _useDate.setFocusedInput;

  var maxDate = maxYear + "-12-31";

  var addPropsInput = _extends({
    size: size
  }, inputProps);

  var addPropsLabel = _extends({
    fontSize: size
  }, formLabelProps);

  var formErrorMessage = _extends({
    fontSize: size
  }, formErrorMessageProps);

  return React.createElement(StylesProvider, {
    styles: styles,
    overwriteDefaultStyles: overwriteDefaultStyles
  }, React.createElement(Box, {
    position: "relative",
    ref: datepickerWrapperRef
  }, React.createElement(FormControl, {
    isInvalid: !!error
  }, label && React.createElement(FormLabel, Object.assign({}, addPropsLabel), label), React.createElement(Input, Object.assign({
    type: "date",
    ref: ref,
    id: id,
    name: name,
    "aria-label": phrases.dateAriaLabel,
    value: formatDateToISO(date),
    placeholder: placeholder || phrases.datePlaceholder,
    dateFormat: displayFormat,
    showCalendarIcon: showCalendarIcon,
    isActive: showDatepicker,
    max: maxDate,
    onBlur: function onBlur(e) {
      if (focusedInput && e.target.id === id && e.target.value) {
        handleInputChange(new Date(e.target.value));
      }
    },
    onClick: function onClick() {
      handleOnFocusChange(true);

      _onClick();
    },
    disableAccessibility: false,
    iconComponent: iconComponent,
    allowEditableInputs: allowEditableInputs,
    hideResetDateAddon: hideResetDateAddon,
    handleResetDate: handleResetDate,
    handleOnFocusChange: handleOnFocusChange,
    sx: {
      '::-webkit-calendar-picker-indicator': {
        display: 'none'
      }
    }
  }, addPropsInput)), React.createElement(FormErrorMessage, Object.assign({}, formErrorMessage), error)), React.createElement(Box, Object.assign({
    position: "absolute",
    top: placement === 'bottom' ? getWrapperPosition(size) : undefined,
    bottom: placement === 'top' ? getWrapperPosition(size) : undefined
  }, datePickerBoxProps), showDatepicker && React.createElement(Datepicker, {
    changeActiveMonthOnSelect: changeActiveMonthOnSelect,
    dayLabelFormat: dayLabelFormat,
    displayFormat: displayFormat,
    endDate: date,
    startDate: date,
    onFocus: function onFocus() {
      return setFocusedInput(null);
    },
    exactMinBookingDays: true,
    firstDayOfWeek: firstDayOfWeek,
    focusedInput: showDatepicker ? START_DATE$1 : null,
    initialVisibleMonth: initialVisibleMonth,
    isDateBlocked: isDateBlocked,
    maxBookingDate: maxBookingDate,
    minBookingDate: minBookingDate,
    minBookingDays: 1,
    monthLabelFormat: function monthLabelFormat(date) {
      return format(date, 'MMMM yyyy', {
        locale: es
      });
    },
    numberOfMonths: numberOfMonths,
    onClose: handleDatepickerClose,
    onDatesChange: handleOnDatesChange,
    onDayRender: onDayRender,
    phrases: phrases,
    ref: datepickerRef,
    showClose: showClose,
    showResetDates: showResetDate,
    showSelectedDates: false,
    unavailableDates: unavailableDates,
    vertical: vertical,
    weekdayLabelFormat: function weekdayLabelFormat(date) {
      return format(date, 'eeeeee', {
        locale: es
      });
    },
    isRangePicker: false
  }))));
});
export { DateRangeInput, DateSingleInput, Datepicker, dateIsEqual, dateRangeInputPhrases, dateSingleInputPhrases, datepickerPhrases, dayLabelFormatFn, defaultDisplayFormat, defaultMaxYear, formatDateDatepicker, formatDateToISO, formatValidYear };